package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets6 {
  internal val _20_micha_01_txt: AssetResource by lazy { init__20_micha_01_txt() }

  internal val _20_micha_02_txt: AssetResource by lazy { init__20_micha_02_txt() }

  internal val _20_micha_03_txt: AssetResource by lazy { init__20_micha_03_txt() }

  internal val _20_micha_04_txt: AssetResource by lazy { init__20_micha_04_txt() }

  internal val _20_micha_05_txt: AssetResource by lazy { init__20_micha_05_txt() }

  internal val _20_micha_06_txt: AssetResource by lazy { init__20_micha_06_txt() }

  internal val _20_micha_07_txt: AssetResource by lazy { init__20_micha_07_txt() }

  internal val _21_nachum_01_txt: AssetResource by lazy { init__21_nachum_01_txt() }

  internal val _21_nachum_02_txt: AssetResource by lazy { init__21_nachum_02_txt() }

  internal val _21_nachum_03_txt: AssetResource by lazy { init__21_nachum_03_txt() }

  internal val _22_havakuk_01_txt: AssetResource by lazy { init__22_havakuk_01_txt() }

  internal val _22_havakuk_02_txt: AssetResource by lazy { init__22_havakuk_02_txt() }

  internal val _22_havakuk_03_txt: AssetResource by lazy { init__22_havakuk_03_txt() }

  internal val _23_tzefania_01_txt: AssetResource by lazy { init__23_tzefania_01_txt() }

  internal val _23_tzefania_02_txt: AssetResource by lazy { init__23_tzefania_02_txt() }

  internal val _23_tzefania_03_txt: AssetResource by lazy { init__23_tzefania_03_txt() }

  internal val _24_haggai_01_txt: AssetResource by lazy { init__24_haggai_01_txt() }

  internal val _24_haggai_02_txt: AssetResource by lazy { init__24_haggai_02_txt() }

  internal val _25_zecharia_01_txt: AssetResource by lazy { init__25_zecharia_01_txt() }

  internal val _25_zecharia_02_txt: AssetResource by lazy { init__25_zecharia_02_txt() }

  internal val _25_zecharia_03_txt: AssetResource by lazy { init__25_zecharia_03_txt() }

  internal val _25_zecharia_04_txt: AssetResource by lazy { init__25_zecharia_04_txt() }

  internal val _25_zecharia_05_txt: AssetResource by lazy { init__25_zecharia_05_txt() }

  internal val _25_zecharia_06_txt: AssetResource by lazy { init__25_zecharia_06_txt() }

  internal val _25_zecharia_07_txt: AssetResource by lazy { init__25_zecharia_07_txt() }

  internal val _25_zecharia_08_txt: AssetResource by lazy { init__25_zecharia_08_txt() }

  internal val _25_zecharia_09_txt: AssetResource by lazy { init__25_zecharia_09_txt() }

  internal val _25_zecharia_10_txt: AssetResource by lazy { init__25_zecharia_10_txt() }

  internal val _25_zecharia_11_txt: AssetResource by lazy { init__25_zecharia_11_txt() }

  internal val _25_zecharia_12_txt: AssetResource by lazy { init__25_zecharia_12_txt() }

  internal val _25_zecharia_13_txt: AssetResource by lazy { init__25_zecharia_13_txt() }

  internal val _25_zecharia_14_txt: AssetResource by lazy { init__25_zecharia_14_txt() }

  internal val _26_malachi_01_txt: AssetResource by lazy { init__26_malachi_01_txt() }

  internal val _26_malachi_02_txt: AssetResource by lazy { init__26_malachi_02_txt() }

  internal val _26_malachi_03_txt: AssetResource by lazy { init__26_malachi_03_txt() }

  internal val _27_tehilim_001_txt: AssetResource by lazy { init__27_tehilim_001_txt() }

  internal val _27_tehilim_002_txt: AssetResource by lazy { init__27_tehilim_002_txt() }

  internal val _27_tehilim_003_txt: AssetResource by lazy { init__27_tehilim_003_txt() }

  internal val _27_tehilim_004_txt: AssetResource by lazy { init__27_tehilim_004_txt() }

  internal val _27_tehilim_005_txt: AssetResource by lazy { init__27_tehilim_005_txt() }

  internal val _27_tehilim_006_txt: AssetResource by lazy { init__27_tehilim_006_txt() }

  internal val _27_tehilim_007_txt: AssetResource by lazy { init__27_tehilim_007_txt() }

  internal val _27_tehilim_008_txt: AssetResource by lazy { init__27_tehilim_008_txt() }

  internal val _27_tehilim_009_txt: AssetResource by lazy { init__27_tehilim_009_txt() }

  internal val _27_tehilim_010_txt: AssetResource by lazy { init__27_tehilim_010_txt() }

  internal val _27_tehilim_011_txt: AssetResource by lazy { init__27_tehilim_011_txt() }

  internal val _27_tehilim_012_txt: AssetResource by lazy { init__27_tehilim_012_txt() }

  internal val _27_tehilim_013_txt: AssetResource by lazy { init__27_tehilim_013_txt() }

  internal val _27_tehilim_014_txt: AssetResource by lazy { init__27_tehilim_014_txt() }

  internal val _27_tehilim_015_txt: AssetResource by lazy { init__27_tehilim_015_txt() }

  internal fun values(): List<AssetResource> = listOf(_20_micha_01_txt, _20_micha_02_txt,
      _20_micha_03_txt, _20_micha_04_txt, _20_micha_05_txt, _20_micha_06_txt, _20_micha_07_txt,
      _21_nachum_01_txt, _21_nachum_02_txt, _21_nachum_03_txt, _22_havakuk_01_txt,
      _22_havakuk_02_txt, _22_havakuk_03_txt, _23_tzefania_01_txt, _23_tzefania_02_txt,
      _23_tzefania_03_txt, _24_haggai_01_txt, _24_haggai_02_txt, _25_zecharia_01_txt,
      _25_zecharia_02_txt, _25_zecharia_03_txt, _25_zecharia_04_txt, _25_zecharia_05_txt,
      _25_zecharia_06_txt, _25_zecharia_07_txt, _25_zecharia_08_txt, _25_zecharia_09_txt,
      _25_zecharia_10_txt, _25_zecharia_11_txt, _25_zecharia_12_txt, _25_zecharia_13_txt,
      _25_zecharia_14_txt, _26_malachi_01_txt, _26_malachi_02_txt, _26_malachi_03_txt,
      _27_tehilim_001_txt, _27_tehilim_002_txt, _27_tehilim_003_txt, _27_tehilim_004_txt,
      _27_tehilim_005_txt, _27_tehilim_006_txt, _27_tehilim_007_txt, _27_tehilim_008_txt,
      _27_tehilim_009_txt, _27_tehilim_010_txt, _27_tehilim_011_txt, _27_tehilim_012_txt,
      _27_tehilim_013_txt, _27_tehilim_014_txt, _27_tehilim_015_txt)
}

private fun init__20_micha_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-01.txt\")") as String, rawPath =
    "allChapters/_20_micha-01.txt")

private fun init__20_micha_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-02.txt\")") as String, rawPath =
    "allChapters/_20_micha-02.txt")

private fun init__20_micha_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-03.txt\")") as String, rawPath =
    "allChapters/_20_micha-03.txt")

private fun init__20_micha_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-04.txt\")") as String, rawPath =
    "allChapters/_20_micha-04.txt")

private fun init__20_micha_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-05.txt\")") as String, rawPath =
    "allChapters/_20_micha-05.txt")

private fun init__20_micha_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-06.txt\")") as String, rawPath =
    "allChapters/_20_micha-06.txt")

private fun init__20_micha_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_20_micha-07.txt\")") as String, rawPath =
    "allChapters/_20_micha-07.txt")

private fun init__21_nachum_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_21_nachum-01.txt\")") as String, rawPath =
    "allChapters/_21_nachum-01.txt")

private fun init__21_nachum_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_21_nachum-02.txt\")") as String, rawPath =
    "allChapters/_21_nachum-02.txt")

private fun init__21_nachum_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_21_nachum-03.txt\")") as String, rawPath =
    "allChapters/_21_nachum-03.txt")

private fun init__22_havakuk_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_22_havakuk-01.txt\")") as String, rawPath =
    "allChapters/_22_havakuk-01.txt")

private fun init__22_havakuk_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_22_havakuk-02.txt\")") as String, rawPath =
    "allChapters/_22_havakuk-02.txt")

private fun init__22_havakuk_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_22_havakuk-03.txt\")") as String, rawPath =
    "allChapters/_22_havakuk-03.txt")

private fun init__23_tzefania_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_23_tzefania-01.txt\")") as String, rawPath =
    "allChapters/_23_tzefania-01.txt")

private fun init__23_tzefania_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_23_tzefania-02.txt\")") as String, rawPath =
    "allChapters/_23_tzefania-02.txt")

private fun init__23_tzefania_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_23_tzefania-03.txt\")") as String, rawPath =
    "allChapters/_23_tzefania-03.txt")

private fun init__24_haggai_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_24_haggai-01.txt\")") as String, rawPath =
    "allChapters/_24_haggai-01.txt")

private fun init__24_haggai_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_24_haggai-02.txt\")") as String, rawPath =
    "allChapters/_24_haggai-02.txt")

private fun init__25_zecharia_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-01.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-01.txt")

private fun init__25_zecharia_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-02.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-02.txt")

private fun init__25_zecharia_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-03.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-03.txt")

private fun init__25_zecharia_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-04.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-04.txt")

private fun init__25_zecharia_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-05.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-05.txt")

private fun init__25_zecharia_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-06.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-06.txt")

private fun init__25_zecharia_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-07.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-07.txt")

private fun init__25_zecharia_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-08.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-08.txt")

private fun init__25_zecharia_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-09.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-09.txt")

private fun init__25_zecharia_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-10.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-10.txt")

private fun init__25_zecharia_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-11.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-11.txt")

private fun init__25_zecharia_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-12.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-12.txt")

private fun init__25_zecharia_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-13.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-13.txt")

private fun init__25_zecharia_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_25_zecharia-14.txt\")") as String, rawPath =
    "allChapters/_25_zecharia-14.txt")

private fun init__26_malachi_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_26_malachi-01.txt\")") as String, rawPath =
    "allChapters/_26_malachi-01.txt")

private fun init__26_malachi_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_26_malachi-02.txt\")") as String, rawPath =
    "allChapters/_26_malachi-02.txt")

private fun init__26_malachi_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_26_malachi-03.txt\")") as String, rawPath =
    "allChapters/_26_malachi-03.txt")

private fun init__27_tehilim_001_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-001.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-001.txt")

private fun init__27_tehilim_002_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-002.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-002.txt")

private fun init__27_tehilim_003_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-003.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-003.txt")

private fun init__27_tehilim_004_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-004.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-004.txt")

private fun init__27_tehilim_005_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-005.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-005.txt")

private fun init__27_tehilim_006_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-006.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-006.txt")

private fun init__27_tehilim_007_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-007.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-007.txt")

private fun init__27_tehilim_008_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-008.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-008.txt")

private fun init__27_tehilim_009_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-009.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-009.txt")

private fun init__27_tehilim_010_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-010.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-010.txt")

private fun init__27_tehilim_011_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-011.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-011.txt")

private fun init__27_tehilim_012_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-012.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-012.txt")

private fun init__27_tehilim_013_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-013.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-013.txt")

private fun init__27_tehilim_014_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-014.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-014.txt")

private fun init__27_tehilim_015_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_27_tehilim-015.txt\")") as String, rawPath =
    "allChapters/_27_tehilim-015.txt")

public actual val SharedRes.assets.allChapters._20_micha_01_txt: AssetResource
  get() = CommonMainAssets6._20_micha_01_txt

public actual val SharedRes.assets.allChapters._20_micha_02_txt: AssetResource
  get() = CommonMainAssets6._20_micha_02_txt

public actual val SharedRes.assets.allChapters._20_micha_03_txt: AssetResource
  get() = CommonMainAssets6._20_micha_03_txt

public actual val SharedRes.assets.allChapters._20_micha_04_txt: AssetResource
  get() = CommonMainAssets6._20_micha_04_txt

public actual val SharedRes.assets.allChapters._20_micha_05_txt: AssetResource
  get() = CommonMainAssets6._20_micha_05_txt

public actual val SharedRes.assets.allChapters._20_micha_06_txt: AssetResource
  get() = CommonMainAssets6._20_micha_06_txt

public actual val SharedRes.assets.allChapters._20_micha_07_txt: AssetResource
  get() = CommonMainAssets6._20_micha_07_txt

public actual val SharedRes.assets.allChapters._21_nachum_01_txt: AssetResource
  get() = CommonMainAssets6._21_nachum_01_txt

public actual val SharedRes.assets.allChapters._21_nachum_02_txt: AssetResource
  get() = CommonMainAssets6._21_nachum_02_txt

public actual val SharedRes.assets.allChapters._21_nachum_03_txt: AssetResource
  get() = CommonMainAssets6._21_nachum_03_txt

public actual val SharedRes.assets.allChapters._22_havakuk_01_txt: AssetResource
  get() = CommonMainAssets6._22_havakuk_01_txt

public actual val SharedRes.assets.allChapters._22_havakuk_02_txt: AssetResource
  get() = CommonMainAssets6._22_havakuk_02_txt

public actual val SharedRes.assets.allChapters._22_havakuk_03_txt: AssetResource
  get() = CommonMainAssets6._22_havakuk_03_txt

public actual val SharedRes.assets.allChapters._23_tzefania_01_txt: AssetResource
  get() = CommonMainAssets6._23_tzefania_01_txt

public actual val SharedRes.assets.allChapters._23_tzefania_02_txt: AssetResource
  get() = CommonMainAssets6._23_tzefania_02_txt

public actual val SharedRes.assets.allChapters._23_tzefania_03_txt: AssetResource
  get() = CommonMainAssets6._23_tzefania_03_txt

public actual val SharedRes.assets.allChapters._24_haggai_01_txt: AssetResource
  get() = CommonMainAssets6._24_haggai_01_txt

public actual val SharedRes.assets.allChapters._24_haggai_02_txt: AssetResource
  get() = CommonMainAssets6._24_haggai_02_txt

public actual val SharedRes.assets.allChapters._25_zecharia_01_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_01_txt

public actual val SharedRes.assets.allChapters._25_zecharia_02_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_02_txt

public actual val SharedRes.assets.allChapters._25_zecharia_03_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_03_txt

public actual val SharedRes.assets.allChapters._25_zecharia_04_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_04_txt

public actual val SharedRes.assets.allChapters._25_zecharia_05_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_05_txt

public actual val SharedRes.assets.allChapters._25_zecharia_06_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_06_txt

public actual val SharedRes.assets.allChapters._25_zecharia_07_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_07_txt

public actual val SharedRes.assets.allChapters._25_zecharia_08_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_08_txt

public actual val SharedRes.assets.allChapters._25_zecharia_09_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_09_txt

public actual val SharedRes.assets.allChapters._25_zecharia_10_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_10_txt

public actual val SharedRes.assets.allChapters._25_zecharia_11_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_11_txt

public actual val SharedRes.assets.allChapters._25_zecharia_12_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_12_txt

public actual val SharedRes.assets.allChapters._25_zecharia_13_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_13_txt

public actual val SharedRes.assets.allChapters._25_zecharia_14_txt: AssetResource
  get() = CommonMainAssets6._25_zecharia_14_txt

public actual val SharedRes.assets.allChapters._26_malachi_01_txt: AssetResource
  get() = CommonMainAssets6._26_malachi_01_txt

public actual val SharedRes.assets.allChapters._26_malachi_02_txt: AssetResource
  get() = CommonMainAssets6._26_malachi_02_txt

public actual val SharedRes.assets.allChapters._26_malachi_03_txt: AssetResource
  get() = CommonMainAssets6._26_malachi_03_txt

public actual val SharedRes.assets.allChapters._27_tehilim_001_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_001_txt

public actual val SharedRes.assets.allChapters._27_tehilim_002_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_002_txt

public actual val SharedRes.assets.allChapters._27_tehilim_003_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_003_txt

public actual val SharedRes.assets.allChapters._27_tehilim_004_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_004_txt

public actual val SharedRes.assets.allChapters._27_tehilim_005_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_005_txt

public actual val SharedRes.assets.allChapters._27_tehilim_006_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_006_txt

public actual val SharedRes.assets.allChapters._27_tehilim_007_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_007_txt

public actual val SharedRes.assets.allChapters._27_tehilim_008_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_008_txt

public actual val SharedRes.assets.allChapters._27_tehilim_009_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_009_txt

public actual val SharedRes.assets.allChapters._27_tehilim_010_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_010_txt

public actual val SharedRes.assets.allChapters._27_tehilim_011_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_011_txt

public actual val SharedRes.assets.allChapters._27_tehilim_012_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_012_txt

public actual val SharedRes.assets.allChapters._27_tehilim_013_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_013_txt

public actual val SharedRes.assets.allChapters._27_tehilim_014_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_014_txt

public actual val SharedRes.assets.allChapters._27_tehilim_015_txt: AssetResource
  get() = CommonMainAssets6._27_tehilim_015_txt
